<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="clickQuery"
              type="search"
              v-model.trim="form.searchKey"
              placeholder="角色名称/创建人/修改人搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add' })"
              v-allow="'actAdd'"
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="actExport()"
              v-allow="'actExport'"
            >
              <b-icon-download></b-icon-download>导出
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="visible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-form-item label="角色状态">
            <el-col :span="24">
              <el-checkbox-group v-model="form.roleStatusList">
                <el-checkbox label="Y" name="type">有效</el-checkbox>
                <el-checkbox label="N" name="type">无效</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
          <el-form-item label="角色名称">
            <el-col :span="24">
              <el-input
                v-model="form.roleName"
                maxlength="50"
                placeholder="请输入角色名称"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="修改日期">
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyTimeStart"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyTimeEnd"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消查询</el-button>
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="clickQuery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        searchKey: '',
        roleStatusList: ['Y'],
      },
    }
  },
  created() {
    this.query()

    let _this = this
    this.$eventBus.$on('roleTableReload', function() {
      _this.query()
    })
  },
  methods: {
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'system-role-detail',
        params: { ...params, pageType },
      })
    },
    actExport() {
      let url = '/sys/role/export'
      let fileName = '角色信息导出'
      this.$api.globalExportData(url, this.form, fileName)
    },
    clickQuery() {
      this.$emit('reset')
      this.query()
      this.closeDialog()
    },
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    reset() {
      this.form = {
        searchKey: '',
        roleStatusList: ['Y'],
      }
      this.$emit('reset')
      this.query()
      this.closeDialog()
    },

    closeDialog() {
      this.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
